import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IQBRPartner } from 'partner360/models/qbr/IQBRPartners'

export const hasSobCompetitorsStep = (qbrPartners: IQBRPartner[], qbrOfferings: ProgramTypes[]) => {
  return (
    qbrPartners.length === 1 &&
    (qbrOfferings.includes(ProgramTypes.CorePrint) ||
      qbrOfferings.includes(ProgramTypes.PersonalSystems) ||
      qbrOfferings.includes(ProgramTypes.Print) ||
      qbrOfferings.includes(ProgramTypes.PC))
  )
}
